import { Component, inject, signal } from '@angular/core';
import { CurrentUserService } from '../../../../common/current-user/current-user.service';
import { CreateScreeningService } from '../../services/create-screening/create-screening.service';
import { ImageService } from '../../../../services/image/image.service';
import { ProductService } from '../../../../services/product/product.service';
import { AddDocumentComponent } from '../../../../atoms/add-document/add-document.component';
import { FormField } from '@angular/forms/signals';
import { WysiswygComponent } from '../../../../atoms/wysiswyg/wysiswyg.component';
import { MatCalendarCellClassFunction, MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'screening-requirements',
  standalone: true,
  imports: [FormField, AddDocumentComponent, WysiswygComponent, MatDatepickerModule, MatFormFieldModule, MatInputModule],
  templateUrl: './requirements.component.html',
  styleUrl: './requirements.component.css'
})
export class ScreeningRequirementsComponent {

  briefProvisionOptions: { id: number, name: string, description: string }[] = [
    { id: 1, name: 'Upload Document', description: 'Upload a PDF, Word document or PowerPoint document defining your brief.' },
    { id: 2, name: 'Type Requirements', description: 'Manually enter the screening requirements.' }
  ]

  selectedBriefProvision = signal<{ id: number, name: string, description: string } | undefined>({ id: 1, name: 'Upload Document', description: 'Upload a PDF, Word document or PowerPoint document defining your brief.' });

  today: Date = new Date();
  dateClass: MatCalendarCellClassFunction<Date> = (cellDate, view) => {
    if (view === 'month') {
      const date = cellDate.getDate();
    }
    return '';
  };

  /** Services */
  public createScreeningService = inject(CreateScreeningService);
  /** Services - END */



  onDocumentUploaded(event: { file: string, fileKey: string, fullUrl: string }) {
    this.createScreeningService.requirementsDocumentUrl.set(event.fullUrl);
  }
  
  onHtmlContentChange(event: string, type: 'requirements' | 'restrictions') {
    if (type === 'requirements') {
      this.createScreeningService.requirementsHtml.set(event);
    } else {
      this.createScreeningService.restrictionsHtml.set(event);
    }
  }
  
  onDateChange(event: any) {
    this.createScreeningService.screenContentUntil.set(event);
  }
}
